import React from "react";

type PROPS = {
  tooltip?: string;
};

const AppTooltip: React.FC<PROPS> = ({ tooltip = ''}) => {

  return (
    <React.Fragment>
      {tooltip && (
        <span
          className="mx-4 w-6 h-6 flex items-center justify-center shrink-0 text-white font-semibold bg-jhk-blue cursor-pointer rounded-full"
          data-tooltip={tooltip}
        >
          ?
        </span>
      )}
    </React.Fragment>
  );
};

export default AppTooltip;
